<template>
    <div>
        <form class="form">
            <div class="alert--error" v-if="error !== undefined && error.length > 0">{{error}}</div>

            <!-- TODO add a loading indicator -->
            <div v-if="loading">LOADING</div>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class ActivationPage extends Vue {
        name = 'activation-page';

        error = '';
        loading = true;

        /**
         * Activate an account
         */
        activate() {
            //TODO show loading state
            this.error = undefined;
            this.loading = true;

            var token = this.$route.params.token;
            this.$auth.activate()
                .then(() => {
                    this.loading = false;

                    //TODO show success message?
                    this.$router.replace({ name: 'sign-in' });
                })
                .catch((e) => {
                    this.loading = false;

                    if (e.response && e.response.data) {
                        var data = e.response.data;
                        this.error = data.errors[0].message;
                        console.error('[ Login ]', this.error);
                    }
                });
        }
    }

    Vue.component('activation-page', ActivationPage);
</script>



// WEBPACK FOOTER //
// src/components/auth/ActivationPage.vue